import { sva } from '@agapi/ui/panda/css'

export const  blogPostStyles = sva({
  slots: ['headerSection', 'headerContainer', 'image', 'title', 'meta', 'content', 'richText'],
  base: {
    headerSection: {
      pt: 0,
      pb: 0
    },
    headerContainer: {
      gap: '4',
      alignItems: 'center'
    },
    image: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
      borderBottomRadius: 'surface.sm'
    },
    title: {
      color: 'text.heading',
      textAlign: 'center'
    },
    meta: {
      display: 'flex',
      color: 'text.subdued',
      fontSize: 'sm',
      gap: '4',
      alignItems: 'center'
    },
    content: {
      fontSize: 'lg',
      lineHeight: '1.6',
      color: 'text.body'
    },
    richText: {
      '& h2': { color: 'text.heading' }
    }
  }
});